<template>
  <div>
    <div
      class="page_container goodsManageSet"
      v-loading="loading"
      element-loading-text="请稍后"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
      <div class="breadcrumb flex-rowl">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/manage' }"
            >SKU管理</el-breadcrumb-item
          >
          <el-breadcrumb-item :to="{ path: '/commondityIndex/cManageIndex' }"
            >商品管理</el-breadcrumb-item
          >
          <el-breadcrumb-item>多币种价格设置</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="form_container">
        <h1>多币种价格设置</h1>
        <div class="account_btn" @click="handleAccount">自动汇率核算</div>
        <div class="content_wrap">
          <div class="form_wrap">
            <div class="block">
              <div class="block_item">
                <p>越南盾零售底价</p>
                <div class="input_box">
                  <el-input
                    type="number"
                    v-model="formData.yue_price_base"
                    placeholder="越南盾零售底价"
                  ></el-input>
                </div>
              </div>
              <div class="block_item">
                <p>越南盾团批底价</p>
                <div class="input_box">
                  <el-input
                    type="number"
                    v-model="formData.yue_tuan_base"
                    placeholder="越南盾团批底价"
                  ></el-input>
                </div>
              </div>
              <div class="block_item">
                <p>越南盾零售价</p>
                <div class="input_box">
                  <el-input
                    type="number"
                    v-model="formData.yue_price"
                    placeholder="越南盾零售价"
                  ></el-input>
                </div>
              </div>
              <div class="block_item">
                <p>越南盾团批价</p>
                <div class="input_box">
                  <el-input
                    type="number"
                    v-model="formData.yue_tuan"
                    placeholder="越南盾团批价"
                  ></el-input>
                </div>
              </div>
            </div>
            <div class="block">
              <div class="block_item">
                <p>泰铢零售底价</p>
                <div class="input_box">
                  <el-input
                    type="number"
                    v-model="formData.tai_price_base"
                    placeholder="铢零售底价"
                  ></el-input>
                </div>
              </div>
              <div class="block_item">
                <p>泰铢团批底价</p>
                <div class="input_box">
                  <el-input
                    type="number"
                    v-model="formData.tai_tuan_base"
                    placeholder="泰铢团批底价"
                  ></el-input>
                </div>
              </div>
              <div class="block_item">
                <p>泰铢零售价</p>
                <div class="input_box">
                  <el-input
                    type="number"
                    v-model="formData.tai_price"
                    placeholder="泰铢零售价"
                  ></el-input>
                </div>
              </div>
              <div class="block_item">
                <p>泰铢团批价</p>
                <div class="input_box">
                  <el-input
                    type="number"
                    v-model="formData.tai_tuan"
                    placeholder="泰铢团批价"
                  ></el-input>
                </div>
              </div>
            </div>
            <div class="block">
              <div class="block_item">
                <p>卢布零售底价</p>
                <div class="input_box">
                  <el-input
                    type="number"
                    v-model="formData.lu_price_base"
                    placeholder="卢布零售底价"
                  ></el-input>
                </div>
              </div>
              <div class="block_item">
                <p>卢布团批底价</p>
                <div class="input_box">
                  <el-input
                    type="number"
                    v-model="formData.lu_tuan_base"
                    placeholder="卢布团批底价"
                  ></el-input>
                </div>
              </div>
              <div class="block_item">
                <p>卢布零售价</p>
                <div class="input_box">
                  <el-input
                    type="number"
                    v-model="formData.lu_price"
                    placeholder="卢布零售价"
                  ></el-input>
                </div>
              </div>
              <div class="block_item">
                <p>卢布团批价</p>
                <div class="input_box">
                  <el-input
                    type="number"
                    v-model="formData.lu_tuan"
                    placeholder="卢布团批价"
                  ></el-input>
                </div>
              </div>
            </div>
            <div class="block">
              <div class="block_item">
                <p>加拿大元零售底价</p>
                <div class="input_box">
                  <el-input
                    type="number"
                    v-model="formData.jia_price_base"
                    placeholder="加拿大元零售底价"
                  ></el-input>
                </div>
              </div>
              <div class="block_item">
                <p>加拿大元团批底价</p>
                <div class="input_box">
                  <el-input
                    type="number"
                    v-model="formData.jia_tuan_base"
                    placeholder="加拿大元团批底价"
                  ></el-input>
                </div>
              </div>
              <div class="block_item">
                <p>加拿大元零售价</p>
                <div class="input_box">
                  <el-input
                    type="number"
                    v-model="formData.jia_price"
                    placeholder="加拿大元零售价"
                  ></el-input>
                </div>
              </div>
              <div class="block_item">
                <p>加拿大元团批价</p>
                <div class="input_box">
                  <el-input
                    type="number"
                    v-model="formData.jia_tuan"
                    placeholder="加拿大元团批价"
                  ></el-input>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="form_footer flex-rowl">
        <div class="btn" @click="query">确认</div>
        <div class="return_txt" @click="handleReturn">←返回</div>
      </div>
    </div>
  </div>
</template>

<script>
import { encryptstringview } from "../../../api/api";
import {
  accountShopMultiPrice,
  getShopMultiPrice,
  addShopMultiPrice,
  editShopMultiPrice,
} from "../../../api/shop";
export default {
  name: "cMultiPrice",
  data() {
    return {
      loading: false,

      formData: {
        cmid: "",
        yue_price_base: "",
        yue_tuan_base: "",
        yue_price: "",
        yue_tuan: "",
        tai_price_base: "",
        tai_tuan_base: "",
        tai_price: "",
        tai_tuan: "",
        lu_price_base: "",
        lu_tuan_base: "",
        lu_price: "",
        lu_tuan: "",
        jia_price_base: "",
        jia_tuan_base: "",
        jia_price: "",
        jia_tuan: "",
      },
      multiPriceDetail: "",
    };
  },
  created() {
    let { routerList, OPENID } = this.$store.state;
    let { name } = this.$route;
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id } = JSON.parse(res.jsondata);
        this.formData.cmid = id;
        this.getShopMultiPrice();
      } else {
        this.$router.back();
      }
    },

    // 获取多币种价格
    getShopMultiPrice() {
      getShopMultiPrice({ cmid: this.formData.cmid }).then((res) => {
        this.multiPriceDetail = res;
        if(res.id) {
          this.formData.yue_price_base = res.yue_price_base;
        this.formData.yue_tuan_base = res.yue_tuan_base;
        this.formData.yue_price = res.yue_price;
        this.formData.yue_tuan = res.yue_tuan;
        this.formData.tai_price_base = res.tai_price_base;
        this.formData.tai_tuan_base = res.tai_tuan_base;
        this.formData.tai_price = res.tai_price;
        this.formData.tai_tuan = res.tai_tuan;
        this.formData.lu_price_base = res.lu_price_base;
        this.formData.lu_tuan_base = res.lu_tuan_base;
        this.formData.lu_price = res.lu_price;
        this.formData.lu_tuan = res.lu_tuan;
        this.formData.jia_price_base = res.jia_price_base;
        this.formData.jia_tuan_base = res.jia_tuan_base;
        this.formData.jia_price = res.jia_price;
        this.formData.jia_tuan = res.jia_tuan;
        }
        
      });
    },
    // 多币种自动核算
    handleAccount() {
      accountShopMultiPrice({ cmid: this.formData.cmid }).then((res) => {
        this.formData.yue_price_base = res.yue_price_base;
        this.formData.yue_tuan_base = res.yue_tuan_base;
        this.formData.yue_price = res.yue_price;
        this.formData.yue_tuan = res.yue_tuan;
        this.formData.tai_price_base = res.tai_price_base;
        this.formData.tai_tuan_base = res.tai_tuan_base;
        this.formData.tai_price = res.tai_price;
        this.formData.tai_tuan = res.tai_tuan;
        this.formData.lu_price_base = res.lu_price_base;
        this.formData.lu_tuan_base = res.lu_tuan_base;
        this.formData.lu_price = res.lu_price;
        this.formData.lu_tuan = res.lu_tuan;
        this.formData.jia_price_base = res.jia_price_base;
        this.formData.jia_tuan_base = res.jia_tuan_base;
        this.formData.jia_price = res.jia_price;
        this.formData.jia_tuan = res.jia_tuan;
      });
    },

    handleReturn() {
      // history.back();
      this.$router.push({ name: "cManageIndex" });
    },

    query() {
      let { formData, multiPriceDetail } = this;
      if (formData.yue_price_base == "") {
        this.$message("请输入越南盾零售底价");
        return;
      }
      if (formData.yue_tuan_base == "") {
        this.$message("请输入越南盾团批底价");
        return;
      }
      if (formData.yue_price == "") {
        this.$message("请输入越南盾零售价");
        return;
      }
      if (formData.yue_tuan == "") {
        this.$message("请输入越南盾团批价");
        return;
      }
      if (formData.tai_price_base == "") {
        this.$message("请输入铢零售底价");
        return;
      }
      if (formData.tai_tuan_base == "") {
        this.$message("请输入泰铢团批底价");
        return;
      }
      if (formData.tai_price == "") {
        this.$message("请输入泰铢零售价");
        return;
      }
      if (formData.tai_tuan == "") {
        this.$message("请输入泰铢团批价");
        return;
      }
      if (formData.lu_price_base == "") {
        this.$message("请输入卢布零售底价");
        return;
      }
      if (formData.lu_tuan_base == "") {
        this.$message("请输入卢布团批底价");
        return;
      }
      if (formData.yue_price_base == "") {
        this.$message("请输入");
        return;
      }
      if (formData.lu_price == "") {
        this.$message("请输入卢布零售价");
        return;
      }
      if (formData.lu_tuan == "") {
        this.$message("请输入卢布团批价");
        return;
      }
      if (formData.jia_price_base == "") {
        this.$message("请输入加拿大元零售底价");
        return;
      }
      if (formData.jia_tuan_base == "") {
        this.$message("请输入加拿大元团批底价");
        return;
      }
      if (formData.jia_price == "") {
        this.$message("请输入加拿大元零售价");
        return;
      }
      if (formData.jia_tuan == "") {
        this.$message("请输入加拿大元团批价");
        return;
      }
      let params = formData;
      this.loading = true;
      if (multiPriceDetail.id) {
        editShopMultiPrice(params).then((res) => {
          let data = res;
          if (data.result) {
            this.loading = false;
            this.$message.success(data.message);
            // setTimeout(() => {
            //   this.loading = false;
            //   this.$router.back();
            // }, 500);
          } else {
            this.loading = false;
            this.$message.error(data.message || "服务器报错，请稍后～");
          }
        });
      } else {
        addShopMultiPrice(params).then((res) => {
          let data = res;
          if (data.result) {
            this.$message.success(data.message);
            setTimeout(() => {
              this.loading = false;
              this.$router.back();
            }, 500);
          } else {
            this.loading = false;
            this.$message.error(data.message || "服务器报错，请稍后～");
          }
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManageSet {
  .account_btn {
    margin-bottom: 30px;
    width: 130px;
    height: 45px;
    background: #f62560;
    border: 1px solid rgba(173, 173, 173, 0.76);
    border-radius: 25px;
    font-size: 18px;
    color: #fff;
    text-align: center;
    line-height: 45px;
    cursor: pointer;
  }
  .block_item {
    margin-bottom: 15px;
  }
}
</style>